import { useState } from "react";
import { feedTabs, todayItems } from "@/mocks/home";

export default function TodayFeed() {
  const [tab, setTab] = useState(feedTabs[0]);

  return (
    <section id="feed" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        {/* 模块头 */}
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-flashlight-fill" aria-hidden="true" />今日上新 · 实时同步
            </span>
            <h2 className="mt-4 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              今日更新 · 新内容速递
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              按时间段把今天的新资源与最新合集整理好。想快速扫一眼今天有什么，从「全部速递」看起最省心。
            </p>
          </div>
          <a href="#today" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
            查看完整更新日志 <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        {/* 速递筛选 */}
        <div className="mt-7 flex flex-wrap gap-2">
          {feedTabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTab(t)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-xs transition-colors cursor-pointer ${
                tab === t
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* 时间轴卡片 */}
        <div className="mt-8 space-y-4">
          {todayItems.map((it) => (
            <article
              key={it.title}
              className="grid grid-cols-1 items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 md:grid-cols-[auto_1fr_auto] md:p-6"
            >
              <div className="flex items-center gap-3 md:flex-col md:gap-1 md:items-start md:w-20">
                <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">{it.time}</span>
                <div className="flex items-center gap-2 md:hidden">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">{it.tag}</span>
                  {it.dot && <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] text-accent-700">{it.dot}</span>}
                </div>
              </div>

              <div className="min-w-0">
                <div className="mb-2 hidden items-center gap-2 md:flex">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">{it.tag}</span>
                  {it.dot && <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] text-accent-700">{it.dot}</span>}
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{it.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{it.desc}</p>
              </div>

              <div className="flex items-center gap-5 md:flex-col md:items-end">
                <span className="inline-flex items-center gap-3 text-xs text-foreground-500 md:text-[11px]">
                  <span className="flex items-center gap-1"><i className="ri-eye-line" aria-hidden="true" />{it.views}</span>
                  <span className="flex items-center gap-1"><i className="ri-message-2-line" aria-hidden="true" />{it.comments}</span>
                </span>
                <a
                  href="#cta"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-3 py-1.5 text-xs font-medium text-primary-700 hover:bg-primary-50"
                >
                  <i className="ri-download-2-line" aria-hidden="true" />查看入口
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}